<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   @click="$router.push({name: 'campaign', params: {campaignId: $route.params.campaignId}})"
                                   v-on="on"
                            >
                                <v-icon x-large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Go Back</span>
                    </v-tooltip>
                    Unlock Class
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12"
                   lg="4"
                   xl="3"
                   v-for="(characterClass, characterClassIndex) of characterClasses"
                   :key="characterClassIndex">

                <v-card>
                    <v-card-title>
                        <v-avatar size="32" class="mb-2 mr-2">
                            <v-img :src="getClassAvatar(characterClass)"/>
                        </v-avatar>
                        {{ characterClass.name }}
                    </v-card-title>

                    <v-divider/>

                    <v-card-actions>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       color="primary"
                                       @click="attachCharacterClass(characterClass)"
                                       v-on="on"
                                >
                                    <v-icon>mdi-lock-open</v-icon>
                                </v-btn>
                            </template>
                            <span>Unlock Class</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import CampaignService from "../services/CampaignService";
  import CharacterClassService from "../services/CharacterClassService";

  export default {
    data: () => ({
      characterClasses: []
    }),

    created() {
      this.detachedScenarios();
    },

    methods: {
      detachedScenarios() {
        CharacterClassService.detachedByCampaign(this.$route.params.campaignId)
          .then(response => {
            this.characterClasses = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      attachCharacterClass(characterClass) {
        if (confirm(`Are you sure you want to unlock the class ${characterClass.name} for this campaign?`)) {
          CampaignService.attachCharacterClass(this.$route.params.campaignId, {
            character_class_id: characterClass.id
          })
            .then(() => {
              this.detachedScenarios();
            })
            .catch(err => {
              console.log(err);
            });
        }
      },

      getClassAvatar(characterClass) {
        try {
          return require(`@/assets/${characterClass.slug}.png`);
        } catch (e) {
          return "";
        }
      }
    }
  };
</script>
